import { AvatarProps } from "@fluentui/react-components";
import { ENTITY_MAP, ENTITY_ICONS, ALLOWED_CONTENT_TYPES } from './Constants';

export const getAvatar = (image: { mime: string; base64stream: string }): Partial<AvatarProps> => {
  return {
    color: "colorful",
    image: {
      src: `data:${image.mime};base64,${image.base64stream}`,
    },
  };
};

export const getEntityId = (entity: string) => {
  return ENTITY_MAP[entity];
};

export const isEntityOfType = (entity: string, targetEntity: string) => {
  return entity === targetEntity;
};

export const getEntityIcon = (entity: string, size: 20 | 24) => {
  const entityIcons = ENTITY_ICONS[entity];
  return entityIcons ? entityIcons[size] : null;
};

export const base64ToBlob = (base64: string, contentType: string) => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
};

export const formatDateTime = (datetimeStr: string) => {
  const year = datetimeStr.slice(0, 4);
  const month = datetimeStr.slice(4, 6);
  const day = datetimeStr.slice(6, 8);
  const hours = datetimeStr.slice(9, 11);
  const minutes = datetimeStr.slice(12, 14);

  const formattedTime = `${hours}:${minutes}`;
  const formattedDate = `${day}-${month}-${year}`;

  return `${formattedTime} / ${formattedDate}`;
};

export function createLocalUrl(path: string) {
  return `${window.location.origin}/${path}`;
}

export function allowedContentType(documentType: string) {
  return ALLOWED_CONTENT_TYPES.includes(documentType);
}